import { GDPRCookie } from '@wkda/gdprlib';
import { GDPR_BANNER_ENABLED, isProduction } from 'config';
import Cookies from 'universal-cookie';

/**
 *
 * @param {Object} availableCookies
 * @param {string} name
 * @param {boolean?} _GDPR_BANNER_ENABLED
 * @returns {Promise<boolean>}
 */
export async function isGdprCookiePermited(
  availableCookies,
  name,
  _GDPR_BANNER_ENABLED,
) {
  const isCookieCleanupPermitted =
    _GDPR_BANNER_ENABLED !== undefined
      ? _GDPR_BANNER_ENABLED
      : availableCookies[GDPR_BANNER_ENABLED] === 'true';

  if (isCookieCleanupPermitted && availableCookies) {
    try {
      const gdprCookieService = await GDPRCookie.init(
        availableCookies,
        new Cookies(availableCookies),
        isProduction,
      );

      return gdprCookieService.isPermitted(name);
    } catch (_) {
      return false;
    }
  }

  return true;
}
